
import { Component, Mixins, Ref } from 'vue-property-decorator'
import StepNavigation from '../StepNavigation.vue'
import FormButtons from '../FormButtons.vue'
import axios from 'axios'
import { API_URLS, SITE_URLS } from '@/utils/helpers'
import StepContainer from '../commons/StepContainer.vue'
import EditAdditionalStep from '../additional_steps/EditAdditionalStep.vue'
import { IPhoto } from '@/types/photos'
import DocumentField from '../commons/fields/DocumentField.vue'
import FormContainer from '../commons/forms/FormContainer.vue'
import ProjectBaseInformationForm from './forms/ProjectBaseInformationForm.vue'
import LocationForm from '../commons/forms/LocationForm.vue'
import ContactPersonSelect from '../commons/forms/ContactPersonSelect.vue'
import SelectBankAccount from './forms/SelectBankAccount.vue'
import ProjectStepMixin from './mixins/ProjectStepMixin.vue'
import ProjectBaseInformationMixin from './mixins/ProjectBaseInformationMixin.vue'
import ProjectAdditionalStepMixin from './mixins/ProjectAdditionalStepMixin.vue'
import ResultReportForm from './forms/ResultReportForm.vue'
import ResultReportMixin from './mixins/ResultReportMixin.vue'
import ProcessingStepMixin from '../ProcessingStepMixin.vue'
import AdminCompletitionForm from './forms/completition_forms/AdminCompletitionForm.vue'
import AccountProjectIsLiveForm from './forms/completition_forms/AccountProjectIsLiveForm.vue'
import ProjectFinancingNeedsForm from "@/components/processing_steps/project/forms/ProjectFinancingNeedsForm.vue"
import AccountPublishProjectForm from './forms/completition_forms/AccountPublishProjectForm.vue'
import { IResultReportForm, ISubCategory } from '@/types/foerderApp'
import { IPSAddtitionalProcessingStep, IPSAdminCompletionForm, IPSEditProject, IPSMinimalContactPerson, IPSSelectOption, IProcessingStep } from '@/types/processingSteps'
import AccountProjectsOrgaWaitingForReview from './forms/completition_forms/AccountProjectsOrgaWaitingForReview.vue'
import AccountProjectWaitingForReview from './forms/completition_forms/AccountProjectWaitingForReview.vue'
import SelectFundingScope from './forms/SelectFundingScope.vue'
import AccountProjectIsPaused from './forms/completition_forms/AccountProjectIsPaused.vue'
import AccountProjectIsFinished from './forms/completition_forms/AccountProjectIsFinished.vue'
import AdminSelectForm from "@/components/processing_steps/commons/forms/AdminSelectForm.vue"
import ConfirmModal from '@/components/processing_steps/commons/modals/ConfirmModal.vue'
import WhatWeNeedStepMixin from './mixins/WhatWeNeedStepMixin.vue'
import WhatWeNeed from './forms/WhatWeNeed.vue'
import ProjectSummaryMixin from './mixins/ProjectSummaryMixin.vue'
import DetailedFinancingNeeds from '../commons/forms/DetailedFinancingNeeds.vue'
import LocaleMixin from '@/mixins/LocaleMixin'
import ProjectForeignOrgaInfo from './forms/ProjectForeignOrgaInfo.vue'
import SubCategoryForm from '../commons/forms/SubCategoryForm.vue'
import ForeignOrgaActivityCode from '../organization/forms/ForeignOrgaActivityCode.vue'
import CharField from '../commons/fields/CharField.vue'
import SingleSelectField from '../commons/fields/SingleSelectField.vue'
import OrgaInfoBanner from '../banners/OrgaInfoBanner.vue'

@Component({
  components: {
    AdminSelectForm,
    ProjectFinancingNeedsForm,
    StepNavigation,
    FormButtons,
    StepContainer,
    EditAdditionalStep,
    DocumentField,
    FormContainer,
    ProjectBaseInformationForm,
    LocationForm,
    ContactPersonSelect,
    SelectBankAccount,
    ProjectStepMixin,
    ProjectBaseInformationMixin,
    ProjectAdditionalStepMixin,
    ResultReportForm,
    ResultReportMixin,
    ProcessingStepMixin,
    AdminCompletitionForm,
    AccountProjectIsLiveForm,
    AccountPublishProjectForm,
    AccountProjectsOrgaWaitingForReview,
    AccountProjectWaitingForReview,
    SelectFundingScope,
    AccountProjectIsPaused,
    AccountProjectIsFinished,
    ConfirmModal,
    WhatWeNeed,
    DetailedFinancingNeeds,
    ProjectForeignOrgaInfo,
    SubCategoryForm,
    ForeignOrgaActivityCode,
    CharField,
    SingleSelectField,
    OrgaInfoBanner
  }
})
export default class EditProject extends Mixins(
  WhatWeNeedStepMixin,
  ProjectStepMixin,
  ProjectBaseInformationMixin,
  ProjectAdditionalStepMixin,
  ResultReportMixin,
  ProcessingStepMixin,
  ProjectSummaryMixin,
  LocaleMixin
) {
  @Ref() contactPersonSelect!: ContactPersonSelect
  @Ref() subCategoryForm!: SubCategoryForm

  activeStep = null

  exitstingPhotos: IPhoto[] = []
  existingDocuments: IPhoto[] = []

  projectSlug: string | null = null

  accountPublishProjectTermsAccepted = false

  selectedAdmins: string[] = []

  finishModalOpen = false

  pauseModalOpen = false

  isLimitedToOwnFundingPages = false

  differentProjectCategoryIds = []

  foreignOrgaInfoForm = {
    realization_time_in_days: null,
    initial_situation: "",
    planned_activities: "",
    risk_factors: "",
    goals_and_impact: "",
    partner_organizations: ""
  }

  foreignOrgaInfoFormErrors = {
    realization_time_in_days: "",
    initial_situation: "",
    planned_activities: "",
    risk_factors: "",
    goals_and_impact: ""
  }

  foreignOrgaActivityForm = {
    main_focus_area_code: "",
    ts_activity_code: ""
  }

  baseInformationFormErrors = {
    title: "",
    street: "",
    postal_code: "",
    city: "",
    country: "",
    region: "",
    additional_information: "",
    longitude: "",
    latitude: "",
    main_focus_area_code: "",
    ts_activity_code: "",
    funding_scope: "",
    category: "",
    goal_in_cents: ""
  }

  get fieldsAreLocked (): boolean {
    return !this.projectIsDraft
  }

  get isFinancingNeedsEditable (): boolean {
    return this.projectIsDraft
  }

  get selectAbleFundingScopes (): IPSSelectOption[] {
    const fundingScopes = (this.project?.available_funding_scopes as IPSSelectOption[]) || []

    if (
      this.project &&
      this.project.funding_scope &&
      !fundingScopes.some(option => option.value === this.project.funding_scope.slug)
    ) {
      fundingScopes.push({
        value: this.project.funding_scope.slug,
        text: this.project.funding_scope.name
      })
    }

    return fundingScopes
  }

  onRegionOptionsFetched (regionOptionsAvailable: boolean) {
    this.regionOptionsAvailable = regionOptionsAvailable
  }

  getPostUrlForFundingAccount (projectSlug: string) {
    // todo collect all required api urls (create project on foerderapp demo and get the url and also which data in which format is sent.)
    // e.g. project is created:
    // POST /api/v3/projects/???
    // data: title: string, category: string (category.slug) and so on
    // put the urls in API_URLS and find a suitable name

    // here it is: funding_pot: "donation-bank-account" (bank account slug)
    // the api endpoint reads the param funding_pot and
    // then knows which serializer to use to save the data
    if (!this.isSiteAdmin) {
      return "/api/v3/projects/" + projectSlug + "/?funding_pot&own"
    } else {
      return "/api/v3/projects/" + projectSlug + "/?funding_pot"
    }
  }

  getPostUrlForSelectedAdmins (projectSlug: string) {
    if (!this.isSiteAdmin) {
      return "/api/v4/projects/" + projectSlug + "/add-administrator/?own"
    } else {
      return "/api/v4/projects/" + projectSlug + "/add-administrator/"
    }
  }

  getCompletionUrl(projectSlug: string) {
    if (this.isSiteAdmin) {
      return "/api/v3/projects/" + projectSlug + "/?publish"
    } else {
      return "/api/v3/projects/" + projectSlug + "/?own&publish"
    }
  }

  getProjectSlug (): void {
    const currentUrl = window.location.pathname
    if (currentUrl.endsWith("update/")) {
      this.projectSlug = currentUrl.split("project/")[1].split("/update/")[0]
    } else {
      this.projectSlug = null
    }
  }

  get orgaWaitingForReview (): boolean {
    return !this.project.live && this.project.organization.current_status.in_review
  }

  get projectWaitingForReview (): boolean {
    return !this.project.live && !this.projectIsPaused && this.project.organization.in_foreign_country
  }

  get requiredStepsComplete (): boolean {
    const requiredStepsKeys = [
      "basic",
      "what_we_need",
      "contact_persons"
    ]
    if (this.project.tags_available) {
      requiredStepsKeys.push("assignment")
    }
    for (const key of requiredStepsKeys) {
      const step = this.steps.find(step => step.key === key)
      if (step && !step.completed) {
        return false
      }
    }
    return true
  }

  get projectIsLive (): boolean {
    return (this.project && this.project.live && !this.projectIsFinished) || false
  }

  get projectIsDraft (): boolean {
    return this.project?.is_status_draft || false
  }

  get projectIsPaused (): boolean {
    return this.project?.status === 4 || false
  }

  get projectIsFinished (): boolean {
    return this.project?.is_finished || false
  }

  get orgaIsWaitingForReview (): boolean {
    return this.project?.organization?.current_status?.show_organization_not_live_banner || false
  }

  get photoUploadUrl (): string {
    if (!this.project) { return "" }
    return API_URLS.PHOTOS.UPLOAD_PHOTO(this.project.photo_album_slug)
  }

  get documentUploadUrl (): string {
    if (!this.project) { return "" }
    return API_URLS.PHOTOS.UPLOAD_PHOTO(this.project.what_we_need.document_album_slug)
  }

  get contactPersonUrl(): string {
    return API_URLS.CONTACT_PERSON.LIST
  }

  get addContactPersonToInstanceUrl(): string {
    return API_URLS.CONTACT_PERSON.ADD_TO_INSTANCE
  }

  get isCreate (): boolean {
    return this.projectSlug === null
  }

  get projectListUrl (): string {
    return this.isSiteAdmin ? "/site-admin/projects-new/" : "/account/projects-new/"
  }

  get projectDetailUrl (): string {
    if (!this.projectSlug) {
      return ""
    }
    return "/project/" + this.projectSlug + "/"
  }

  get projectPreviewUrl (): string {
    return "/project/" + this.project.slug + "/?preview_token=" + this.project.preview_token
  }

  get createProjectUrl (): string {
    return this.isSiteAdmin ? "/site-admin/projects/create/" : "/account/projects/create/"
  }

  get publicContactPersonTableItem (): IPSMinimalContactPerson[] {
    return this.project ? [this.project.public_contact_person] : []
  }

  get inForeignCountry (): boolean {
    return this.project.organization.country !== 'DE'
  }

  get financingNeedIsValid (): boolean {
    if (!this.inForeignCountry) {
      return this.financeForm.goal_in_cents > 0
    } else {
      return Object.values(this.detailedFinancingNeedsForm).some(item => {
        return item.need_in_cents > 0 && item.description !== ''
      })
    }
  }

  get foreignOrgaActivityIsValid (): boolean {
    if (!this.inForeignCountry) {
      return true
    }
    return this.foreignOrgaActivityForm.main_focus_area_code !== "" && this.foreignOrgaActivityForm.ts_activity_code !== ""
  }

  async mounted (): Promise<void> {
    await this.setAllData()
  }

  async setAllData (): Promise<void> {
    this.getProjectSlug()
    await this.fetchProject()
    this.setAvailableOrganizations(this.project.available_organizations)
    this.setSteps()
    this.setActiveStep(null)
    this.setProjectBaseInformationForm(this.project)
    this.setWhatWeNeedForm(this.project)
    this.setForeignOrgaInfoForm(this.project)
    this.setAvailableProjectCategories(this.project.available_project_categories)
    this.setProjectLocationForm(this.project)
    this.setProjectFinanceForm(this.project)
    this.setProjectCompletionForm(this.project)
    this.setDetailedFinancingNeedsForm(this.project)
    this.setForeignOrgaActivityForm(this.project)
    this.selectedAdmins = this.project?.admins?.map(admin => admin.username) || []
    this.selectedFundingScopesSlug = this.project?.funding_scope?.slug ? this.project.funding_scope.slug : ''
    this.isLimitedToOwnFundingPages = this.project.is_limited_to_own_funding_pages
    this.steps.forEach(step => {
      this.checkAndValidateStep(step)
    })
    this.updateBreadCrumbs()
  }

  setForeignOrgaActivityForm (project: IPSEditProject): void {
    if (!this.inForeignCountry) {
      return
    }
    this.foreignOrgaActivityForm = {
      main_focus_area_code: project.main_focus_area_code || project.organization.main_focus_area_code || "",
      ts_activity_code: project.ts_activity_code || project.organization.ts_activity_code || ""
    }
  }

  setForeignOrgaInfoForm (project: IPSEditProject): void {
    if (!this.inForeignCountry) {
      return
    }
    this.foreignOrgaInfoForm = {
      realization_time_in_days: project.realization_time_in_days,
      initial_situation: project.initial_situation || "",
      planned_activities: project.planned_activities || "",
      risk_factors: project.risk_factors || "",
      goals_and_impact: project.goals_and_impact || "",
      partner_organizations: project.partner_organizations || ""
    }
  }

  setDetailedFinancingNeedsForm (project: IPSEditProject): void {
    if (!project || !project.detailed_financing_need) {
      return
    }
    this.detailedFinancingNeedsForm = {
      investments: {
        need_in_cents: (parseFloat(project.detailed_financing_need.investments.need_in_cents) / 100).toFixed(2),
        description: project.detailed_financing_need.investments.description
      },
      operating_costs: {
        need_in_cents: (parseFloat(project.detailed_financing_need.operating_costs.need_in_cents) / 100).toFixed(2),
        description: project.detailed_financing_need.operating_costs.description
      },
      staff_costs: {
        need_in_cents: (parseFloat(project.detailed_financing_need.staff_costs.need_in_cents) / 100).toFixed(2),
        description: project.detailed_financing_need.staff_costs.description
      },
      other_costs: {
        need_in_cents: (parseFloat(project.detailed_financing_need.other_costs.need_in_cents) / 100).toFixed(2),
        description: project.detailed_financing_need.other_costs.description
      }
    }
  }

  async onPublicContactPersonChanged (): Promise<void> {
    await this.fetchProject()
    this.checkAndValidateStep(this.activeStep)
  }

  async saveResultReport (resultReportForm: IResultReportForm): Promise<boolean> {
    let saved = false
    const url = API_URLS.RESULT_REPORT.RETRIEVE(this.resultReportSlug)
    await axios.put(url, resultReportForm)
      .then(async () => {
        this.showSuccessMsg(null)
        saved = true
        await this.fetchProject()
        this.checkAndValidateStep(this.activeStep)
      }).catch(() => {
        this.showError(null)
      })
    return saved
  }

  setWhatWeNeedForm (project: IPSEditProject): void {
    this.whatWeNeedForm.slug = project.what_we_need?.slug || ""
    this.whatWeNeedForm.description = project.what_we_need?.description || ""
    this.whatWeNeedForm.links = project.what_we_need?.links || []
    this.whatWeNeedForm.document_album_slug = project.what_we_need?.document_album_slug || ""
    this.whatWeNeedForm.page_heading = project.page_heading || ""
  }

  resetWhatWeNeedFormErrors (): void {
    this.whatWeNeedFormErrors = {
      title: '',
      description: '',
      mission_statement: '',
      founding_year: '',
      annual_budget: '',
      page_heading: ''
    }
    this.foreignOrgaInfoFormErrors = {
      realization_time_in_days: "",
      initial_situation: "",
      planned_activities: "",
      risk_factors: "",
      goals_and_impact: ""
    }
  }

  resetBaseInformationFormErrors (): void {
    this.baseInformationFormErrors = {
      title: "",
      street: "",
      postal_code: "",
      city: "",
      country: "",
      region: "",
      additional_information: "",
      longitude: "",
      latitude: "",
      main_focus_area_code: "",
      ts_activity_code: "",
      funding_scope: "",
      category: "",
      goal_in_cents: ""
    }
  }

  async saveWhatWeNeed (): Promise<boolean> {
    if (!this.photoStepIsValid) {
      this.showMissingImageError()
      return false
    }
    this.resetWhatWeNeedFormErrors()
    let saved = false
    const url = API_URLS.PROJECTS.SAVE_WHAT_WE_NEED(this.projectSlug)
    const data: {
      description: string,
      realization_time_in_days?: number,
      initial_situation?: string,
      planned_activities?: string,
      risk_factors?: string,
      goals_and_impact?: string,
      partner_organizations?: string,
      page_heading: string
    } = {
      description: this.whatWeNeedForm.description,
      page_heading: this.whatWeNeedForm.page_heading
    }
    if (this.inForeignCountry) {
      data.realization_time_in_days = this.foreignOrgaInfoForm.realization_time_in_days
      data.initial_situation = this.foreignOrgaInfoForm.initial_situation
      data.planned_activities = this.foreignOrgaInfoForm.planned_activities
      data.risk_factors = this.foreignOrgaInfoForm.risk_factors
      data.goals_and_impact = this.foreignOrgaInfoForm.goals_and_impact
      data.partner_organizations = this.foreignOrgaInfoForm.partner_organizations
    }
    await axios.put(url, data)
      .then(response => {
        if (response.status === 200) {
          saved = true
        }
      })
      .catch((error) => {
        if (this.inForeignCountry) {
          for (const key in this.foreignOrgaInfoFormErrors) {
            if (error.response.data[key]) {
              this.foreignOrgaInfoFormErrors[key] = error.response.data[key][0]
            }
          }
          for (const key in this.whatWeNeedFormErrors) {
            if (error.response.data[key]) {
              this.whatWeNeedFormErrors[key] = error.response.data[key][0]
            }
          }
        }
      })
    return saved
  }

  async saveAdminCompletionForm (adminCompletionForm: IPSAdminCompletionForm): Promise<boolean> {
    let saved = false
    const url = this.getCompletionUrl(this.projectSlug)
    const data = {
      ...adminCompletionForm,
      administrated_by: this.project.administrated_by
    }
    await axios.put(url, data)
      .then(async () => {
        saved = true
      }).catch(() => {
        const incompleteSteps = this.steps.filter(step => !step.completed)
        if (incompleteSteps.length > 0) {
          const message = incompleteSteps.map(step => step.title).join(", ")
          this.showError({ title: this.$gettext('Please complete all steps'), message })
          this.setActiveStep(incompleteSteps[0])
          return false
        } else {
          this.showError(null)
        }
      })
    return saved
  }

  async resumeProject (): Promise<void> {
    const url = "/api/v3/projects/" + this.projectSlug + "/?resume&own"
    await axios.put(url)
      .then(async () => {
        this.showSuccessMsg(null)
        await this.fetchProject()
      })
      .catch(() => {
        this.showError(null)
      })
  }

  get contactPersonHref (): string {
    if (this.isSiteAdmin) {
      return SITE_URLS.FOERDER_APP.SITE_ADMIN.CONTACT_PERSON.CREATE
    } else {
      return SITE_URLS.FOERDER_APP.ACCOUNT.CONTACT_PERSON.CREATE
    }
  }

  updateBreadCrumbs() {
    // todo do the same for the other components
    // todo add urls
    const tableUrl = this.isSiteAdmin ? "/site-admin/projects-new/" : "/account/projects-new/"
    const createUrl = ""
    let breadcrumbs = []
    const projectIcon = 'projectIcon'
    if (this.isCreate) {
      breadcrumbs = [
        { title: this.$gettext("Project"), url: tableUrl, icon: projectIcon },
        { title: this.$gettext("Create"), url: createUrl }
      ]
    } else {
      breadcrumbs = [
        { title: this.$gettext("Project"), url: tableUrl, icon: projectIcon },
        { title: this.project.title, url: '/processing-steps/' }
      ]
    }
    this.$emit("breadcrumbs-set", breadcrumbs) // emits to ProcessingSteps.vue to set the new breadcrumbs
  }

  async fetchProject(): Promise<void> {
    let url = API_URLS.PROJECTS.CREATE_DATA
    if (this.projectSlug) {
      url = API_URLS.PROJECTS.EDIT_DATA(this.projectSlug)
    }
    try {
      const response = await axios.get(url)
      this.project = response.data
      this.exitstingPhotos = this.project.photos
      if (this.project && this.project.what_we_need) {
        this.existingDocuments = this.project.what_we_need.documents
      }
      // todo additionalSteps have an ordering. You can choose after which step the additional step is added
      // this is for after the first step
      // add the same for the other positions (also in template and ProjectStepMixin)
      this.additionalStepsAfterFirstStep = this.createAdditonalSteps(this.project.additional_steps_base_information)
    } catch {
      this.showError(null)
    }
  }

  handleFilesUploaded (): void {
    this.fetchProject()
  }

  gotoStep (clickedStep: IProcessingStep): void {
    if (!this.baseInformationIsValid) {
      this.showError({ title: 'Error!', message: 'Please fill out the required fields' })
      return
    }
    this.checkAndValidateStep(this.activeStep)
    this.setActiveStep(clickedStep)
  }

  async saveFundingPot (): Promise<boolean> {
    let saved = false
    const fundingPot = this.project.individual_bank_account
    const apiUrl = this.getPostUrlForFundingAccount(this.projectSlug)
    await axios.put(apiUrl, { funding_pot: fundingPot }).then(async () => {
      saved = true
    })
    return saved
  }

  async saveSelectedAdmins (): Promise<boolean> {
    let saved = false
    const selectedAdmins = { administrated_by: this.selectedAdmins } // Wrapping the list in a dictionary
    const apiUrl = this.getPostUrlForSelectedAdmins(this.projectSlug)
    await axios.post(apiUrl, selectedAdmins).then(async () => {
      this.showSuccessMsg(null)
      await this.fetchProject()
      saved = true
      this.checkAndValidateStep(this.activeStep)
    }).catch(() => {
      this.showError(null)
    })
    return saved
  }

  async handlePhotoUpdated (): Promise<void> {
    await this.fetchProject()
    this.checkAndValidateStep(this.activeStep)
  }

  async finishBtnClicked(): Promise<void> {
    const saved = await this.saveCompletion()
    if (saved) {
      this.showSuccessMsg(null)
      this.redirectToTable()
    }
  }

  async saveForeignOrgaActivity (): Promise<void> {
    if (!this.inForeignCountry) {
      return
    }
    const url = API_URLS.PROJECTS.ADD_ACTIVITY_CODE(this.projectSlug)
    await axios.put(url, this.foreignOrgaActivityForm)
      .catch(() => {
        const error = {
          title: this.$gettext('Activity Code!'),
          message: this.$gettext('Your activity code could not be saved. Please contact an admin.')
        }
        this.showError(error)
      })
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setBaseInformationFormErrors (error: any): void {
    this.resetBaseInformationFormErrors()
    const errorMessages = error.response.data
    // set error again in next tick to make sure reactivity works
    this.$nextTick(() => {
      this.baseInformationFormErrors = {
        title: errorMessages.title ? errorMessages.title[0] : "",
        street: errorMessages.street ? errorMessages.street[0] : "",
        postal_code: errorMessages.postal_code ? errorMessages.postal_code[0] : "",
        city: errorMessages.city ? errorMessages.city[0] : "",
        country: errorMessages.country ? errorMessages.country[0] : "",
        region: errorMessages.region ? errorMessages.region[0] : "",
        additional_information: errorMessages.additional_information ? errorMessages.additional_information[0] : "",
        longitude: errorMessages.longitude ? errorMessages.longitude[0] : "",
        latitude: errorMessages.latitude ? errorMessages.latitude[0] : "",
        main_focus_area_code: errorMessages.main_focus_area_code ? errorMessages.main_focus_area_code[0] : "",
        ts_activity_code: errorMessages.ts_activity_code ? errorMessages.ts_activity_code[0] : "",
        funding_scope: errorMessages.funding_scope ? errorMessages.funding_scope[0] : "",
        category: errorMessages.category ? errorMessages.category[0] : "",
        goal_in_cents: errorMessages.goal_in_cents ? errorMessages.goal_in_cents[0] : ""
      }
    })
  }

  async createProject (): Promise<boolean | string> {
    let created = false
    const postData = {
      projectpromoter: this.projectBaseInformationForm.organization,
      title: this.projectBaseInformationForm.title,
      category: this.projectBaseInformationForm.category,
      goal_in_cents: this.goalInCents,
      ...this.projectLocationForm,
      ...this.foreignOrgaActivityForm,
      organization: this.projectBaseInformationForm.organization,
      funding_scope: this.selectedFundingScopesSlug
    }
    let url = "/api/v3/projects/?own"
    if (this.isSiteAdmin) {
      url = "/api/v3/projects/"
    }
    created = await axios.post(url, postData).then(response => {
      return response.data.slug
    }).catch(error => {
      this.setBaseInformationFormErrors(error)
      return false
    })
    return created
  }

  async saveBaseInformation(): Promise<boolean> {
    this.resetBaseInformationFormErrors()
    const url = API_URLS.PROJECTS.SAVE_BASE_INFORMATION(this.projectSlug)
    let saved = false
    const payload = {
      organization: this.projectBaseInformationForm.organization,
      title: this.projectBaseInformationForm.title,
      category: this.projectBaseInformationForm.category,
      funding_scope: this.selectedFundingScopesSlug,
      goal_in_cents: this.goalInCents,
      ...this.projectLocationForm,
      ...this.foreignOrgaActivityForm
    }
    saved = await axios.put(url, payload).then(async () => {
      if (this.isFinancingNeedsEditable) {
        return await this.saveFinancingNeeds()
      }
      return true
    }).catch(error => {
      this.setBaseInformationFormErrors(error)
      return false
    })
    return saved
  }

  async saveBtnClicked (currentStep: IProcessingStep | IPSAddtitionalProcessingStep): Promise<boolean> {
    let saved = false
    if (currentStep.key === "basic") {
      if (this.projectSlug) {
        saved = await this.saveBaseInformation()
      } else {
        const created = await this.createProject()
        this.projectSlug = typeof created === 'string' ? created : null
        if (typeof created === 'string') {
          this.projectSlug = created
          const updateUrl = "/account/project/" + this.projectSlug + "/update/"
          // todo store urls somewhere else
          saved = await this.saveBaseInformation()
          window.history.pushState({}, "", updateUrl)
        }
      }
      if (saved && this.inForeignCountry) {
        this.setDetailedFinancingNeedsForm(this.project)
      }
    } else if (currentStep.key === "individual_bank_account") {
      saved = await this.saveFundingPot()
    } else if (currentStep.key === "result_report") {
      saved = await this.saveResultReport(this.resultReportForm)
    } else if (currentStep.key === "completion") {
      this.saveCompletion()
      saved = true
    } else if (currentStep.key === "what_we_need") {
      saved = await this.saveWhatWeNeed()
    } else if (currentStep.key === 'assignment') {
      saved = this.subCategoryForm.stepIsValid()
      if (!saved) {
        const error = this.subCategoryForm.getError()
        this.showError(error)
      }
    } else if (currentStep.key === "contact_persons") {
      saved = await this.saveContactPersons()
    } else if (currentStep.key === 'photos') {
      this.gotoNextStepOrFinish(this.steps, currentStep, "project")
    } else if (this.isIPSAdditionalProcessingStep(currentStep)) {
      saved = await this.saveAdditionalStep((currentStep as IPSAddtitionalProcessingStep), this.projectSlug)
    }
    if (saved) {
      this.showSuccessMsg(null)
      await this.setAllData()
    } else {
      this.showRequiredFieldsError()
    }
    this.checkAndValidateStep(this.activeStep)
    return saved
  }

  async saveAndNextBtnClicked (currentStep: IProcessingStep): Promise<void> {
    const saved = await this.saveBtnClicked(currentStep)
    if (this.projectSlug) {
      if (this.baseInformationFromIsValid && saved) {
        this.gotoNextStepOrFinish(this.steps, currentStep, "project")
      }
    }
  }

  async saveContactPersons (): Promise<boolean> {
    if (!this.project.has_public_contact_person) {
      this.showAddPublicContactPersonError()
      return false
    }
    if (!this.project.has_internal_contact_person) {
      this.showAddInternalContactPersonError()
      return false
    }
    return await this.saveSelectedAdmins()
  }

  get goalInCents (): number {
    if (this.inForeignCountry) {
      return Object.values(this.detailedFinancingNeedsForm)
        .map(item => {
          const cents = Math.round(parseFloat(item.need_in_cents) * 100)
          return cents
        })
        .reduce((sum, value) => sum + value, 0)
    }
    return this.financeForm.goal_in_cents
  }

  async saveFinancingNeeds (): Promise<boolean> {
    let saved = false
    let savedForeignOrgaNeeds = false
    const goalInCents = this.goalInCents
    if (this.inForeignCountry) {
      savedForeignOrgaNeeds = await this.saveDetailedFinancingNeeds(this.projectSlug)
      this.financeForm.goal_in_cents = goalInCents
    }
    let url = "/api/v3/projectmilestones/"
    const update = this.project && this.project.milestones && this.project.milestones.length > 0
    if (update) {
      url += this.project.milestones[0].slug + "/"
    }

    const data = {
      goal_in_cents: goalInCents,
      project: this.projectSlug,
      title: this.projectSlug + "-title",
      description: this.projectSlug + "-description"
    }
    if (update) {
      saved = await axios.put(url, data).then(() => {
        return true
      }).catch(() => {
        return false
      })
    } else {
      saved = await axios.post(url, data).then(() => {
        return true
      }).catch(() => {
        return false
      })
    }
    if (this.inForeignCountry) {
      return saved && savedForeignOrgaNeeds
    }
    return saved
  }

  async saveDetailedFinancingNeeds (projectSlug: string): Promise<boolean> {
    const payload = {
      investments: {
        description: this.detailedFinancingNeedsForm.investments.description,
        need_in_cents: this.detailedFinancingNeedsForm.investments.need_in_cents = (parseFloat(this.detailedFinancingNeedsForm.investments.need_in_cents) * 100).toFixed(0)
      },
      operating_costs: {
        description: this.detailedFinancingNeedsForm.operating_costs.description,
        need_in_cents: this.detailedFinancingNeedsForm.investments.need_in_cents = (parseFloat(this.detailedFinancingNeedsForm.operating_costs.need_in_cents) * 100).toFixed(0)
      },
      staff_costs: {
        description: this.detailedFinancingNeedsForm.staff_costs.description,
        need_in_cents: this.detailedFinancingNeedsForm.investments.need_in_cents = (parseFloat(this.detailedFinancingNeedsForm.staff_costs.need_in_cents) * 100).toFixed(0)
      },
      other_costs: {
        description: this.detailedFinancingNeedsForm.other_costs.description,
        need_in_cents: this.detailedFinancingNeedsForm.investments.need_in_cents = (parseFloat(this.detailedFinancingNeedsForm.other_costs.need_in_cents) * 100).toFixed(0)
      }
    }
    for (const key in payload) {
      if (payload[key].need_in_cents > 0 && !payload[key].description) {
        this.showError({ title: 'Financing need', message: this.$gettext('Your financing need is missing a description') })
        return
      }
    }
    let saved = false
    saved = await axios.post(API_URLS.PROJECTS.ADD_DETAILED_FINANCING_NEEDS(projectSlug), payload).then(async () => {
      // this.setDetailedFinancingNeedsForm(this.project)
      return true
    }).catch(() => {
      this.showError(null)
      return false
    })
    return saved
  }

  async saveAssignment (): Promise<boolean> {
    let saved = false
    if (!this.selectedFundingScopesSlug) {
      this.showError({ title: 'Error!', message: this.$gettext('Please select a funding scope') })
      this.fundingScopeFormErrors.funding_scope_slug = this.$gettext('This field is required')
      return saved
    }
    let url = "/api/v4/projects/" + this.projectSlug + "/add-funding-scope-to-project/"
    if (!this.isSiteAdmin) {
      url += "?own"
    }
    await axios.post(url, { funding_scope_slug: this.selectedFundingScopesSlug }).then(async () => {
      saved = true
    }).catch(() => {
      this.showError(null)
    })
    return saved
  }

  async saveAdditionalStep (step: IPSAddtitionalProcessingStep, projectSlug: string): Promise<boolean> {
    let saved = false
    const additionalStep = step.additional_step
    const apiUrl = additionalStep.api_url
    const additionalFields = additionalStep.additional_fields
    let contentType = null
    const data = {
      content_type: null,
      object_slug: projectSlug
    }
    for (const field of additionalFields) {
      // If a field has no content type, the field is an photo album, so it is not supposed to be in the request data, because the file is uploaded directly in photocomponent
      if (!field.value.content_type) {
        continue
      }
      contentType = field.value.content_type ? field.value.content_type : contentType
      data[field.slug] = field.value.value
    }
    data.content_type = contentType
    await axios.put(apiUrl, data).then(() => {
      saved = true
      this.setAdditionalStepValid(step)
      const message = additionalStep.title + " " + this.$gettext('saved successfully')
      this.showSuccessMsg({ title: 'Success!', message })
    }).catch(error => {
      this.showError(null)
      this.steps = this.steps.map(step => {
        if ('form_errors' in step) {
          (step as IPSAddtitionalProcessingStep).form_errors = error.response.data
        }
        return step
      })
    })
    return saved
  }

  async saveCompletion (): Promise<boolean> {
    let saved = false
    this.steps[this.steps.length - 1].completed = true
    if (this.isSiteAdmin) {
      saved = await this.saveAdminCompletionForm(this.adminCompletitionForm)
    } else {
      if (this.project.is_status_draft) {
        saved = await this.publishProject()
      } else {
        saved = true
      }
    }
    return saved
  }

  redirectToTable () {
    window.location.href = this.isSiteAdmin ? "/site-admin/projects-new/" : "/account/projects-new/"
  }

  async publishProject (): Promise<boolean> {
    // todo refactor
    const termsAccepted = this.accountPublishProjectTermsAccepted
    if (termsAccepted) {
      this.checkAndValidateStep(this.activeStep)
    }
    const incompleteSteps = this.steps.filter(step => !step.completed)
    if (incompleteSteps.length > 0) {
      const message = incompleteSteps.map(step => step.title).join(", ")
      this.showError({ title: this.$gettext('Please complete all steps'), message })
      this.setActiveStep(incompleteSteps[0])
      return false
    }
    if (!termsAccepted) {
      this.showError({ title: this.$gettext('Please accept the terms and conditions'), message: this.$gettext('You need to accept the terms and conditions to publish the project.') })
      return false
    }
    let saved = false
    const url = this.getCompletionUrl(this.projectSlug)
    const data = {
      terms: termsAccepted,
      is_limited_to_own_funding_pages: this.isLimitedToOwnFundingPages
    }
    await axios.put(url, data).then(async () => {
      saved = true
    })
    return saved
  }

  async pauseFundingRequirement (): Promise<void> {
    // currently only used for orga users
    const url = "/api/v3/projects/" + this.projectSlug + "/?pause&own"
    axios.put(url)
      .then(async () => {
        this.showSuccessMsg(null)
        await this.fetchProject()
      })
      .catch(() => {
        this.showError(null)
      })
  }

  async endFundingRequirement (): Promise<void> {
    const url = "/api/v3/projects/" + this.projectSlug + "/?finish&own"
    await axios.put(url)
      .then(async () => {
        this.showSuccessMsg(null)
        await this.fetchProject()
      })
      .catch(() => {
        this.showError({
          title: this.$gettext("Error"),
          message: this.$gettext("This project is associated with an active funding application.")
        })
      })
  }

  enterOrganizationsAddress (): void {
    this.projectLocationForm.street = this.project.organization.street
    this.projectLocationForm.postal_code = this.project.organization.postal_code
    this.projectLocationForm.city = this.project.organization.city
    this.projectLocationForm.country = this.project.organization.country
    this.projectLocationForm.region = this.project.organization.region
    this.projectLocationForm.additional_information = this.project.organization.additional_information
  }

  onSubCategoriesFetched (subCategories: ISubCategory[]): void {
    if (subCategories.length) {
      const projectCategory = subCategories[0].project_category // this is a number
      if (!this.differentProjectCategoryIds.includes(projectCategory)) {
        this.differentProjectCategoryIds.push(projectCategory)
      }
    }
  }

  onSubCategoryAdded (projectCategoryId: number): void {
    if (!this.differentProjectCategoryIds.includes(projectCategoryId)) {
      this.differentProjectCategoryIds.push(projectCategoryId)
    }
  }

  onSubCategoryRemoved (projectCategoryId: number): void {
    this.differentProjectCategoryIds = this.differentProjectCategoryIds.filter(id => id !== projectCategoryId)
  }

  openAddressBook (): void {
    this.contactPersonSelect.openAddressBook()
  }

  foreignOrgaInfoValid (): boolean {
    const mapping = {
      initial_situation: {
        minLength: 500,
        maxLength: 1500
      },
      planned_activities: {
        minLength: 500,
        maxLength: 1500
      },
      risk_factors: {
        minLength: 500,
        maxLength: 1500
      },
      goals_and_impact: {
        minLength: 500,
        maxLength: 1500
      }
    }
    for (const key in mapping) {
      const text = this.foreignOrgaInfoForm[key]
      const strippedText = text.replace(/<[^>]+>/g, '')
      if (strippedText.length < mapping[key].minLength || strippedText.length > mapping[key].maxLength) {
        return false
      }
    }
    return true
  }

  async checkAndValidateStep(step: IProcessingStep) {
    if (step.key === "completion" && !step.completed) {
      step.completed = !!(this.project.status !== 1 && this.project.status)
    }
    if (step.required === false) {
      this.setAdditionalStepValid(step)
      return
    }
    if (step.key === "basic") {
      if (this.baseInformationIsValid) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === "photos") {
      if (this.photoStepIsValid) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === "contact_persons") {
      if (this.contactPersonIsValid) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === 'individual_bank_account') {
      if (this.project?.individual_bank_account) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === 'result_report') {
      if (this.project.has_public_result_report) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === 'assignment') {
      if (await this.assignmentIsValid()) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === 'financing_needs') {
      if (this.project.goal?.in_cents > 0) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === "what_we_need") {
      if (this.whatWeNeedIsValid) {
        if (this.inForeignCountry) {
          if (this.foreignOrgaInfoValid()) {
            this.setAdditionalStepValid(step)
          } else {
            this.setAdditionalStepInvalid(step)
          }
        } else {
          this.setAdditionalStepValid(step)
        }
      } else {
        this.setAdditionalStepInvalid(step)
      }
    }
  }
}
